import { useEffect, useState } from "react";
import { fetchData, fourTypes, twelveChar } from "../../../../util";
import CharTable from "../../../../assets/images/chartable.png";
import Quarter from "../Quarter";
import BoxTitle from "./BoxTitle";
import GroupHeader from "../GroupHeader";
import "./index.css";
import GroupCovers from "../GroupCovers";
import HalfDoughnutChart from "./chart";
import BarChart from "./barchart";

import adventurer from "../../../../assets/images/adventurer.png";
import advisor from "../../../../assets/images/advisor.png";
import analyst from "../../../../assets/images/analyst.png";
import evaluator from "../../../../assets/images/evaluator.png";
import facilitator from "../../../../assets/images/facilitator.png";
import guardian from "../../../../assets/images/guardian.png";
import innovator from "../../../../assets/images/innovator.png";
import mediator from "../../../../assets/images/mediator.png";
import planner from "../../../../assets/images/planner.png";
import scholar from "../../../../assets/images/scholar.png";
import strategist from "../../../../assets/images/strategist.png";
import visionary from "../../../../assets/images/visionary.png";

import icon_adventurer from "../../../../assets/icons/icon_adventurer.png";
import icon_advisor from "../../../../assets/icons/icon_advisor.png";
import icon_analyst from "../../../../assets/icons/icon_analyst.png";
import icon_evaluator from "../../../../assets/icons/icon_evaluator.png";
import icon_facilitator from "../../../../assets/icons/icon_facilitator.png";
import icon_guardian from "../../../../assets/icons/icon_guardian.png";
import icon_innovator from "../../../../assets/icons/icon_innovator.png";
import icon_mediator from "../../../../assets/icons/icon_mediator.png";
import icon_planner from "../../../../assets/icons/icon_planner.png";
import icon_scholar from "../../../../assets/icons/icon_scholar.png";
import icon_strategist from "../../../../assets/icons/icon_strategist.png";
import icon_visionary from "../../../../assets/icons/icon_visionary.png";

function GroupTables({
  groupinfo,
  countDataMain,
  countDataSub,
  total,
  excelDataMain,
  excelDataSub,
  userdata,
}) {
  const [highMain, setHighMain] = useState([]);
  const [highSub, setHighSub] = useState([]);
  const [contentMain, setContentMain] = useState([]);
  const [contentSub, setContentSub] = useState([]);
  const [resultTeam, setResultTeam] = useState();
  const [balanceDegree, setBalanceDegree] = useState(0);
  const [balanceText, setBalanceText] = useState("");
  const [diversityScore, setDiversityScore] = useState(0);
  const [diversityText, setDiversityText] = useState("");
  const [iconSrc, setIcons] = useState([]);
  const [iconSrc2, setIcons2] = useState([]);
  const [iconText, setIconText] = useState([]);
  const [iconPercentText, setIconPercentText] = useState([]);
  const [barPercent, setBarPercent] = useState([]);
  const [barData, setBarData] = useState([]);
  const [barColor, setBarColor] = useState([]);

  useEffect(() => {
    const maxValueM = Math.max(...Object.values(countDataMain));
    setHighMain(
      Object.keys(countDataMain).filter(
        (key) => countDataMain[key] === maxValueM
      )
    );
    const maxValueS = Math.max(...Object.values(countDataSub));
    setHighSub(
      Object.keys(countDataSub).filter((key) => countDataSub[key] === maxValueS)
    );
    try {
      fetchData("result-team.xlsx").then((res) => setResultTeam(res));
    } catch (error) {
      console.log(error);
    }

    const p1 = (countDataMain["분석형"] / total) * 100;
    const p2 = (countDataMain["관계형"] / total) * 100;
    const p3 = (countDataMain["도전형"] / total) * 100;
    const p4 = (countDataMain["안정형"] / total) * 100;

    const balance =
      (1 -
        (Math.abs(p1 - 25) +
          Math.abs(p2 - 25) +
          Math.abs(p3 - 25) +
          Math.abs(p4 - 25)) /
          150) *
      100;
    setBalanceDegree(balance);

    let text = "";
    if (balance >= 75) {
      text = "· 균형도가 매우 높은 편입니다.";
      text +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "은 4가지 유형이 모두 고르게 분포되어 있습니다.";
      text +=
        "\n\n· 다양한 관점과 능력을 균형있게 활용할 수 있습니다. 특히 협업이나 포괄적인 문제 해결에서 매우 긍정적인 결과를 낼 수 있습니다.";
      text +=
        "\n\n· 팀의 다양성과 공정성을 강조하는 환경에서 큰 강점을 보일 수 있습니다.";
    } else if (balance >= 50) {
      text = "· 균형도가 약간 높은 편입니다.";
      text +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "은 전체적으로 고르게 분포된 역량을 가지고 있습니다. 이는 다양한 상황에서 적응할 수 있는 유연성, 협력적인 분위기를 만들어 낼 수 있다는 뜻입니다.";
      text +=
        "\n\n· 프로젝트나 목표에 따라 전문가로서의 특성을 반영하면서도, 유연하게 대처할 수 있습니다.";
    } else if (balance >= 25) {
      text = "· 균형도가 약간 낮은 편입니다.";
      text +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "은 일부 유형에 집중되어 있지만, 효율성을 추구하면서도 다양한 시각을 받아들일 수 있는 상태입니다.";
      text +=
        "\n\n· 목표 지향적임과 동시에, 유연한 업무 방식을 필요로 하는 상황에 적합하다고 볼 수 있습니다.";
    } else {
      text = "· 균형도가 매우 낮은 편입니다.";
      text +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "의 구성원들이 한가지, 혹은 두가지 유형에 집중되어 있는 상태입니다.";
      text +=
        "\n\n· 특정 분야에 대하여 강한 전문성을 보유한 구성원들이 많은 상황입니다.";
      text +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "은 명확한 목표나, 특정 분야에서 효율적인 결과를 내기에 유리한 팀입니다.";
    }
    setBalanceText(text);

    // calc diversity
    let keys = Object.keys(countDataSub);
    let segment = 0;

    keys.forEach((key) => {
      let p = countDataSub[key] / total;
      if (p != 0) {
        segment -= p * Math.log10(p);
      }
    });
    let diversityScore = (segment / Math.log10(12)) * 200;
    console.log("!", total, segment, segment / Math.log(12), diversityScore);

    let diversityText = "";
    if (diversityScore >= 130) {
      diversityText = "· 다양성 점수가 높은 편입니다!";
      diversityText +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "이 매우 다양한 유형의 사람들로 이루어져 있다는 의미입니다.";
      diversityText +=
        "\n\n· 이 경우, 창의적이거나 혁신성이 요구되는 프로젝트에서 큰 강점이 될 수 있으며, 복잡한 문제 해결 및 전략적 사고에 유리합니다.";
    } else if (diversityScore >= 70) {
      diversityText = "· 다양성 점수가 보통인 편입니다! ";
      diversityText +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "에는 구성원들 간 균형이 잘 이루어져 있다는 의미입니다.";
      diversityText +=
        "\n\n· 여러 유형의 구성원이 골고루 분포되어 있기 때문에 협동이 필요한 업무에서의 시너지 효과를 기대해볼 수 있습니다.";
    } else {
      diversityText = "· 다양성 점수가 낮은 편입니다! ";
      diversityText +=
        "\n\n· " +
        `${groupinfo.groupname}` +
        "이 보다 전문화되고 한 분야에 집중되어 있다는 의미입니다.";
      diversityText +=
        "\n\n· 팀의 일관성이 뚜렷한 편이며, 특정 역량이 필요한 작업에서 보다 효율적일 수 있습니다.";
      diversityText +=
        "\n\n· 또한 구성원들이 비슷한 생각을 가지고 있기에, 빠르게 의사결정을 할 수 있습니다.";
    }

    setDiversityScore(diversityScore);
    setDiversityText(diversityText);

    const sortedData = Object.fromEntries(
      Object.entries(countDataSub).sort(([, a], [, b]) => b - a) // 내림차순 정렬
    );
    let sortedKeys = Object.keys(sortedData);
    let sortedSrc = [];
    let sortedSrc2 = [];
    let sortedText = [];
    let barPercentText = [];
    let sortedPercentText = [];

    let sortedSubType = [];
    let sortedBarData = [];
    let sortedBarColor = [];

    for (let i = 0; i < 12; i++) {
      sortedBarData.push({
        r: 0,
        e: 0,
        a: 0,
        l: 0,
      });
      sortedBarColor.push(["#002060", "#7B7B7B", "#D0D0D0", "#ECEBEA"]);
    }

    let firstKey = null;
    sortedKeys.forEach((key) => {
      sortedSubType.push(key);
      sortedText.push(countDataSub[key] + "명");
      sortedPercentText.push(
        ((countDataSub[key] / total) * 100).toFixed(0) + "%"
      );
      if (firstKey == null) {
        firstKey = key;
        barPercentText.push(70);
      } else {
        barPercentText.push(
          ((countDataSub[key] / countDataSub[firstKey]) * 70).toFixed(0)
        );
      }

      if (key == "모험가") {
        sortedSrc.push(adventurer);
        sortedSrc2.push(icon_adventurer);
      } else if (key == "상담가") {
        sortedSrc.push(advisor);
        sortedSrc2.push(icon_advisor);
      } else if (key == "분석가") {
        sortedSrc.push(analyst);
        sortedSrc2.push(icon_analyst);
      } else if (key == "비평가") {
        sortedSrc.push(evaluator);
        sortedSrc2.push(icon_evaluator);
      } else if (key == "촉진자") {
        sortedSrc.push(facilitator);
        sortedSrc2.push(icon_facilitator);
      } else if (key == "수호자") {
        sortedSrc.push(guardian);
        sortedSrc2.push(icon_guardian);
      } else if (key == "발명가") {
        sortedSrc.push(innovator);
        sortedSrc2.push(icon_innovator);
      } else if (key == "중재자") {
        sortedSrc.push(mediator);
        sortedSrc2.push(icon_mediator);
      } else if (key == "설계자") {
        sortedSrc.push(planner);
        sortedSrc2.push(icon_planner);
      } else if (key == "학자") {
        sortedSrc.push(scholar);
        sortedSrc2.push(icon_scholar);
      } else if (key == "전략가") {
        sortedSrc.push(strategist);
        sortedSrc2.push(icon_strategist);
      } else if (key == "비전가") {
        sortedSrc.push(visionary);
        sortedSrc2.push(icon_visionary);
      }
    });
    setIcons(sortedSrc);
    setIcons2(sortedSrc2);
    setIconText(sortedText);
    setIconPercentText(sortedPercentText);
    setBarPercent(barPercentText);

    userdata.map((user) => {
      const index = sortedSubType.indexOf(user.subType);
      if (user.mainType == "분석형") {
        sortedBarData[index].r += 1;
      } else if (user.mainType == "관계형") {
        sortedBarData[index].e += 1;
      } else if (user.mainType == "도전형") {
        sortedBarData[index].a += 1;
      } else if (user.mainType == "안정형") {
        sortedBarData[index].l += 1;
      }
    });

    for (var i = 0; i < sortedBarData.length; i++) {
      let total =
        sortedBarData[i].r +
        sortedBarData[i].e +
        sortedBarData[i].a +
        sortedBarData[i].l;
      sortedBarData[i].r = ((sortedBarData[i].r / total) * 100).toFixed(0);
      sortedBarData[i].e = ((sortedBarData[i].e / total) * 100).toFixed(0);
      sortedBarData[i].a = ((sortedBarData[i].a / total) * 100).toFixed(0);
      sortedBarData[i].l = ((sortedBarData[i].l / total) * 100).toFixed(0);
      const sortedEntries = Object.entries(sortedBarData[i]).sort(
        ([, valueA], [, valueB]) => valueB - valueA
      );
      const sortedObj = Object.fromEntries(sortedEntries);
      sortedBarData[i] = sortedObj;
      sortedBarData[i].r += "/#002060";
      sortedBarData[i].e += "/#7B7B7B";
      sortedBarData[i].a += "/#D0D0D0";
      sortedBarData[i].l += "/#ECEBEA";
    }

    console.log(sortedBarData);

    setBarData(sortedBarData);
  }, [countDataMain, countDataSub, total]);

  // useEffect(() => {
  //   let typename = "";
  //   if (highMain.length === 1) {
  //     typename = highMain[0];
  //     let array = excelDataMain.filter((item) => item.type === typename);
  //     setContentMain({
  //       strength: array.filter((item) => item.category === "strength_example"),
  //       changes: array.filter((item) => item.category === "change_res"),
  //       motivation: array.filter((item) => item.category === "motivation"),
  //       stress: array.filter((item) => item.category === "stress_tendency")[0],
  //     });
  //   } else if (resultTeam) {
  //     fourTypes.map((type) => {
  //       if (highMain.includes(type.name))
  //         typename = typename + type.nameEng.slice(0, 1);
  //     });
  //     let array = resultTeam.filter((item) => item.type === typename);
  //     setContentMain({
  //       content: [
  //         array.filter((item) => item.category === "strength")[0],
  //         array.filter((item) => item.category === "weakness")[0],
  //       ],
  //       changes: array.filter((item) => item.category === "changes"),
  //       motivation: array.filter((item) => item.category === "motivation"),
  //       stress: array.filter((item) => item.category === "stress")[0],
  //     });
  //   }
  // }, [highMain, resultTeam]);

  // useEffect(() => {
  //   if (highSub.length === 1) {
  //     let array = excelDataSub.filter((item) => item.type === highSub[0]);
  //     setContentSub(
  //       array.filter((item) => item.category === "strength").slice(0, 1)
  //     );
  //   } else if (resultTeam) {
  //     setContentSub(resultTeam.filter((item) => item.type === "SUB"));
  //   }
  // }, [highSub, resultTeam]);
  return (
    <div className="GroupTables page">
      <GroupHeader groupinfo={groupinfo} total={total} />
      {/* <div className="intro">
        {groupinfo.companyname} {groupinfo.groupname} ({total}명 진단) 주요
        결과입니다.
      </div> */}

      <div className="container">
        <div className="content">
          <div className="boxcontent">
            <div className="quarter-box box">
              <h3 style={{ textAlign: "center" }}>
                {groupinfo.groupname}
                <br></br>그룹의 균형도(Balance Degree)
              </h3>
              <div className="table-container">
                <Quarter
                  countData={countDataMain}
                  total={total}
                  current={highMain}
                />
              </div>
              <div className="bottom-text">
                {/* <b>{groupinfo.groupname} 그룹의 균형도 (Balance Degree)</b> */}
                <div
                  className="balance-degree"
                  style={{ marginTop: "0", marginBottom: "18px" }}
                >
                  {balanceDegree.toFixed(0)} %
                </div>
                <div className="balance-text">{balanceText}</div>
                {/* {contentMain.content
                  ? contentMain.content.map((item) => (
                      <div key={item.content}>{item.content}</div>
                    ))
                  : fourTypes.map((type) => {
                      if (type.name === highMain[0]) {
                        return <div key={type.name}>- {type.content}</div>;
                      }
                    })} */}
              </div>
            </div>

            <div className="quarter-box center-box" style={{ width: "200px" }}>
              <div style={{ height: "35px" }}></div>
              {iconSrc.map((item, index) => (
                <div className="groupLogosDiv" key={index}>
                  <img
                    className="groupLogos"
                    alt={iconSrc}
                    src={iconSrc[index]}
                  />
                  <span>{iconPercentText[index]}</span>
                </div>
              ))}
            </div>

            <div className="quarter-box">
              <h3 style={{ textAlign: "center" }}>
                {groupinfo.groupname}
                <br />
                그룹의 다양성 Point
              </h3>
              <HalfDoughnutChart diversityScore={diversityScore} />
              {/* {iconSrc ? (<BarChart iconSrc={iconSrc} />) : <div></div>} */}
              <div style={{ height: "60px" }}></div>
              {iconSrc.map((item, index) => (
                <div className="groupBarDiv" key={index}>
                  <div className="groupBarLogosDiv">
                    <img className="groupBarLogos" src={iconSrc2[index]} />
                  </div>

                  <div
                    className="groupBar"
                    style={{ width: `${barPercent[index]}%` }}
                  >
                    <div
                      className="groupBarChild"
                      style={{
                        width: `${
                          barData[index][Object.keys(barData[index])[0]].split(
                            "/"
                          )[0]
                        }%`,
                        backgroundColor: `${
                          barData[index][Object.keys(barData[index])[0]].split(
                            "/"
                          )[1]
                        }`,
                      }}
                    ></div>
                    <div
                      className="groupBarChild"
                      style={{
                        width: `${
                          barData[index][Object.keys(barData[index])[1]].split(
                            "/"
                          )[0]
                        }%`,
                        backgroundColor: `${
                          barData[index][Object.keys(barData[index])[1]].split(
                            "/"
                          )[1]
                        }`,
                      }}
                    ></div>
                    <div
                      className="groupBarChild"
                      style={{
                        width: `${
                          barData[index][Object.keys(barData[index])[2]].split(
                            "/"
                          )[0]
                        }%`,
                        backgroundColor: `${
                          barData[index][Object.keys(barData[index])[2]].split(
                            "/"
                          )[1]
                        }`,
                      }}
                    ></div>
                    <div
                      className="groupBarChild"
                      style={{
                        width: `${
                          barData[index][Object.keys(barData[index])[3]].split(
                            "/"
                          )[0]
                        }%`,
                        backgroundColor: `${
                          barData[index][Object.keys(barData[index])[3]].split(
                            "/"
                          )[1]
                        }`,
                      }}
                    ></div>
                  </div>
                  <span>{iconText[index]}</span>
                </div>
              ))}
            </div>

            <div
              className="quarter-box box"
              style={{
                width: "175px",
                height: "auto",
                margin: "220px 10px 0px 10px",
              }}
            >
              <h3 style={{ textAlign: "center" }}>Diversity Index</h3>
              <h3 style={{ textAlign: "center" }}>다양성 지수</h3>
              <div className="balance-text">{diversityText}</div>
            </div>

            {/* <div className="char-box box">
              <div className="table-container">
                <img alt="" src={CharTable} /> {}
              </div>
              <div className="bottom-text">
                <b>12 캐릭터 다양성 분포 점수 (총점 200)</b>
                <div className="balance-degree">
                 {diversityScore.toFixed(0)}
                </div>
                <div className="balance-text">{diversityText}</div>
              </div>
            </div>
          </div>
          
          <div className="text-box box">
            {highMain.length === 1 && (
              <div className="text-container">
                <BoxTitle title={`(${groupinfo.groupname}) 업무 스타일`} />
                <div className="text-body">
                  {contentMain.strength &&
                    contentMain.strength.map((item) => (
                      <div key={item.content}>
                        {item.detail.replace(/\\n/g, ` `)}
                      </div>
                    ))}
                </div>
              </div>
            )}
            <div className="text-container motivation">
              <BoxTitle title={`(${groupinfo.groupname}) 동기부여 핵심요소`} />
              <div className={`text-body ${highMain.length > 1}`}>
                {contentMain.motivation &&
                  contentMain.motivation.map((item) => (
                    <div key={item.content} className="item">
                      {item.content}
                    </div>
                  ))}
              </div>
            </div>
            <div className="text-container changes">
              <BoxTitle title={`(${groupinfo.groupname}) 변화 대응 방법`} />
              <div className={`text-body ${highMain.length > 1}`}>
                {contentMain.changes &&
                  contentMain.changes.map((item) => (
                    <div key={item.content} className="item">
                      {highMain.length > 1
                        ? item.content
                        : item.content.replace(/\\n/g, ` `)}
                    </div>
                  ))}
              </div>
            </div>
            <div className="text-container">
              <BoxTitle title={`(${groupinfo.groupname}) 스트레스 반응`} />
              <div className="text-body">
                {contentMain.stress && contentMain.stress.content}
              </div>
            </div>
            <div className="url-container">
              추가 정보와 자세한 해석이 필요하시면
              <br />
              root@rootconsulting.co.kr로 문의하세요.
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GroupTables;
